import { translatedObjectStore } from '@/helpers/translation'

const externalPaymentTranslationsKeys: Record<string, string> = {
  howToWatch: 'how_to_watch',
  toWatchGoToWebsite: 'payment_message_header',
  purchasesAndRentalsCanBeWatchedInApp: 'content_watched_in_app',
  proceedToPurchase: 'proceed_to_purchase',
}

export const $externalPayment = translatedObjectStore(
  externalPaymentTranslationsKeys
)
